import React from "react";
import { Link } from "react-router-dom";

function Rosary() {
  return (
    <div>
      <Link to="/rosary/terms">
        <div>Terms and Conditions</div>
      </Link>
      <Link to="/rosary/policy">
        <div>Privacy Policy</div>
      </Link>
    </div>
  );
}

export default Rosary;
